import { ScoreRing } from "@/components/ScoreRing";
import { StatusPill } from "@/lib/pipeline";
import { Mic, ArrowRight } from "lucide-react";

// Pripravená štruktúra pre budúce moduly pohovoru (zatiaľ bez funkcií)
export const FUTURE_MODULES = ["record", "questions", "fit", "competencies"];

export function InterviewPage({ p, onShowProfile }) {
  const positions = (p.positions || []).filter((x) => x.status === "interview").map((x) => x.name);
  const position = positions.join(", ") || (p.areas || []).join(", ") || p.title || "—";
  return (
    <div data-testid="interview-page">
      <header className="rounded-3xl bg-white border border-slate-200 shadow-sm p-6 flex flex-wrap items-center gap-6" data-testid="interview-header">
        <ScoreRing value={p.career_score || 0} size={88} stroke={8} label="Career Score" />
        <div className="min-w-0 flex-1">
          <h1 className="font-head text-3xl font-bold tracking-tight text-[#1e2a5a]" data-testid="interview-name">{p.name}</h1>
          <p className="mt-1 text-slate-600" data-testid="interview-position">{position}</p>
          <div className="mt-2"><StatusPill status="interview" testId="interview-status" /></div>
        </div>
        <button data-testid="interview-open-profile" onClick={onShowProfile}
          className="inline-flex items-center gap-1.5 rounded-full border border-violet-200 bg-violet-50 px-4 py-2 text-sm font-semibold text-violet-700 hover:bg-violet-100 transition-colors">
          Celý profil <ArrowRight size={15} />
        </button>
      </header>
      <section className="mt-6 rounded-3xl bg-white border border-slate-200 shadow-sm p-6" data-testid="interview-record">
        <h2 className="font-head text-lg font-semibold text-[#1e2a5a] flex items-center gap-2"><Mic size={18} className="text-violet-600" /> Záznam z pohovoru</h2>
        <p className="mt-4 rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center text-sm font-medium text-slate-500" data-testid="interview-placeholder">Pripravuje sa</p>
      </section>
      {/* Priestor pre budúce moduly (FUTURE_MODULES) – zatiaľ sa nevykresľujú */}
    </div>
  );
}
